import { render, staticRenderFns } from "./Code.vue?vue&type=template&id=dc7b222c"
import script from "./Code.vue?vue&type=script&lang=js"
export * from "./Code.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc7b222c')) {
      api.createRecord('dc7b222c', component.options)
    } else {
      api.reload('dc7b222c', component.options)
    }
    module.hot.accept("./Code.vue?vue&type=template&id=dc7b222c", function () {
      api.rerender('dc7b222c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/player/components/Code.vue"
export default component.exports